import { useEffect, useState } from 'react'
import { Divider } from '@material-ui/core'
import axios from 'axios'
import { connect } from 'react-redux'
import { setCurrentSiteId } from '../../AppRedux/actions/Applications'
import { DEFAULT_STATUS } from './constants'
import ApplicationDetails from '../ApplicationDetails'
import SiteList from '../SiteList'
import urlStrings from '../../utils/urlStrings'
import history from '../../routes/history'
import { getSessionToken } from '../../utils/helper'
import { applicationService } from '../../Services/ApplicationService'
import { useStyles } from './styles'
const CustomerSupportSiteApplication = (props) => {
  const { setLoading } = props
  const classes = useStyles()
  const [sites, setSites] = useState([])
  const [selected, setSelected] = useState(null)
  const [status, setStatus] = useState(DEFAULT_STATUS)
  const [totalcount, setTotalCount] = useState(0)
  const [page, setPage] = useState(1)
  useEffect(() => {
    getSites()
  }, [status, page])
  const getSites = () => {
    setLoading(true)
    applicationService.getApplicationsPaginated(10, page, status)
      .then((data) => {
        setSites(data.applications)
        setTotalCount(data.total_count)
        setLoading(false)
        props.setCurrentSiteId('')
      })
      .catch((error) => {
        setLoading(false)
        props.setCurrentSiteId('')
        setSites([])
      })
  }

  return (
    <div className={classes.layout}>
      <SiteList
        sites={sites}
        selected={selected}
        setSelected={setSelected}
        status={status}
        setStatus={setStatus}
        totalcount={totalcount}
        page={page}
        setPage={setPage}
      ></SiteList>
      <Divider
        orientation="vertical"
        flexItem="true"
        classes={{ root: classes.root }}
      ></Divider>
      <ApplicationDetails
        getSites={getSites}
        setLoading={setLoading}
        status={status}
      ></ApplicationDetails>
    </div>
  )
}
const mapDispatchToProps = (dispatch) => ({
  setCurrentSiteId: (payload) => dispatch(setCurrentSiteId(payload)),
})

export default connect(null, mapDispatchToProps)(CustomerSupportSiteApplication)
